import { Grid, Typography, Divider, Box, Paper, Button } from "@mui/material";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useIntl } from "react-intl";
import { Spinner } from "react-bootstrap";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DinamicTable from "components/DinamicTable/DinamicTable";
import { useState } from "react";
import { IconCaretRightFilled, IconCaretLeftFilled } from "@tabler/icons-react";

interface Proveedores {
  id: number;
}

interface Area {
  id_area: number;
  nombre_area: string;
}

interface DetalleInventarioProps {
  verProveedores?: Proveedores[] | null;
  proveedoresPaginados: Proveedores[];
  procesando: boolean;
  page: number;
  rowsPerPage: number;
  handleChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleisAlertOpenDetalleProveedor: () => void;
  setVerDetalleProveedor: React.Dispatch<React.SetStateAction<any>>;
  setVerEditarProveedor: React.Dispatch<React.SetStateAction<any>>;
  getJefeInmediato: (datos: any) => Promise<void>;
  handleisAlertOpenCrearProveedor: () => void;
  desactivarProveedor: (datos: any) => Promise<void>;
  activarProveedor: (datos: any) => Promise<void>;
  getDocumentosFaltantesProveedor: (datos: any) => Promise<void>;
  areas: Area[];
  selectedArea: number | null;
  handleChangeAreaTab: (newIdArea: number) => void;
}

const ProveedorModulo = ({
  verProveedores,
  proveedoresPaginados,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  procesando,
  handleisAlertOpenDetalleProveedor,
  setVerDetalleProveedor,
  getJefeInmediato,
  handleisAlertOpenCrearProveedor,
  setVerEditarProveedor,
  desactivarProveedor,
  activarProveedor,
  getDocumentosFaltantesProveedor,
  areas,
  selectedArea,
  handleChangeAreaTab,
}: DetalleInventarioProps) => {
  if (!verProveedores) return null;
  const intl = useIntl();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    handleChangeAreaTab(newValue);
  };

  const ScrollLeftIcon = () => <IconCaretLeftFilled size={20} stroke={2} />;
  const ScrollRightIcon = () => <IconCaretRightFilled size={20} stroke={2} />;

  const getEstado = (estado: number) => {
    switch (estado) {
      case 1:
        return "success";
      case 0:
        return "error";
      default:
        return "default";
    }
  };

  const estadosMap: { [key: number]: string } = {
    1: "ACTIVADO",
    0: "DESACTIVADO",
  };

  const traducirEstado = (estado: number | null): string => {
    if (estado === null || estado === undefined) return "SIN ESTADO";
    return estadosMap[estado] ?? "SIN ESTADO";
  };

  return (
    <Box sx={{ px: 2, pb: 2, mt: 3 }}>
      <Grid container spacing={3}>
        {/* Información de la talla */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Grid container>
              {/*<Grid item xs={12} md={10}>
                <Typography
                  variant="h6"
                  color="primary"
                  gutterBottom
                  sx={{ color: "#004c93", textAlign: { xs: "center", sm: "left" } }}
                >
                  Proveedores registrados
                </Typography>
              </Grid>*/}
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", sm: "end" },
                }}
              >
                <Button
                  sx={{ color: "#fff", background: "#041d45" }}
                  variant="contained"
                  endIcon={<AddBoxIcon />}
                  onClick={(e: any) => {
                    setVerEditarProveedor(null);
                    handleisAlertOpenCrearProveedor();
                  }}
                >
                  {intl.formatMessage({ id: "nuevo_proveedor" })}
                </Button>
              </Grid>
            </Grid>
            <Divider sx={{ m: 2 }} />
            {verProveedores.length > 0 ? (
              <>
                <Box
                  sx={{
                    borderRadius: 99,
                    width: "100%",
                    p: "4px",
                    boxShadow:
                      "0 0 1px 0 rgba(24, 94, 224, 0.15), 0 3px 6px 0 rgba(24, 94, 224, 0.15)",
                    border: "1px solid #5c6472",
                  }}
                >
                  <Tabs
                    value={selectedArea ?? false}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    aria-label="tabs de áreas"
                    TabIndicatorProps={{ style: { display: "none" } }}
                    TabScrollButtonProps={{
                      slots: {
                        StartScrollButtonIcon: ScrollRightIcon,
                        EndScrollButtonIcon: ScrollLeftIcon,
                      },
                    }}
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        color: "#041d45",
                        borderRadius: "50%",
                        width: 32,
                        height: 32,
                        alignSelf: "center",
                        "&.Mui-disabled": { opacity: 0.3 },
                        "&:hover": { backgroundColor: "rgba(4, 29, 69, 0.08)" },
                      },
                      backgroundColor: "transparent !important",
                    }}
                  >
                    {areas.map((area) => (
                      <Tab
                        key={area.id_area}
                        label={area.nombre_area}
                        value={area.id_area}
                        disableRipple
                        sx={{
                          //minHeight: "unset",
                          borderRadius: 99,
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "1rem",
                          px: 1.5,
                          py: 1.5,
                          mx: 0.25,
                          my: 0.25,
                          color: "#5c6472",
                          transition: "background-color 0.25s ease, color 0.25s ease",
                          "&.Mui-selected": {
                            color: "#fff !important",
                            backgroundColor: "#041d45",
                            boxShadow: "0 1px 3px rgba(4, 29, 69, 0.35)",
                          },
                          "&:hover:not(.Mui-selected)": {
                            backgroundColor: "rgba(4, 29, 69, 0.06)",
                          },
                        }}
                      />
                    ))}
                  </Tabs>
                </Box>
                <DinamicTable
                  key={"tabla"}
                  sinExport
                  canSearch
                  columnsOrder={[
                    //"id",
                    "nombre_comercial",
                    "razon_social",
                    "contacto",
                    "rfc",
                    "estatus",
                  ]}
                  data={verProveedores}
                  esListaProveedores
                  actions
                  enAccion={(accion, row) => {
                    const datos = {
                      id_proveedor: row.id,
                    };
                    if (accion === "ver") {
                      getDocumentosFaltantesProveedor(datos);
                      setVerDetalleProveedor(row);
                      handleisAlertOpenDetalleProveedor();
                    }
                    if (accion === "editar") {
                      setVerEditarProveedor(row);
                      handleisAlertOpenCrearProveedor();
                    }
                    if (accion === "activar") {
                      activarProveedor(datos);
                    }
                    if (accion === "desactivar") {
                      desactivarProveedor(datos);
                    }
                  }}
                />
              </>
            ) : procesando ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "general_cargando_datos" })}
                </Typography>
                <Spinner animation="border" />
              </Box>
            ) : verProveedores?.length === 0 && !procesando ? (
              <Box sx={{ textAlign: "center", py: 2 }}>
                <Typography variant="h6" color="text.secondary">
                  {intl.formatMessage({ id: "no_hay_datos_registrados" })}
                </Typography>
              </Box>
            ) : null}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default ProveedorModulo;
